import React from 'react';
import classNames from 'classnames';

import ProgressLoadingBar from '../ProgressLoadingBar';
import { Icons } from '../Icons';
import { clientLogos } from '../customerkey';
import { useSearchParams } from 'react-router-dom';
import { useCustomerConfig } from '../../hooks/useCustomerConfig';

/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */

function LoadingIndicatorProgress({ className, textBlock, progress }) {
  const [params] = useSearchParams();
  const customerKey = params.get('customerKey');
  const { customer } = useCustomerConfig();
  const headerConfig = (customerKey || customer?.aboutImage) || false;
  const RISEnabled = window.config?.risEnable;
  const bgColor = RISEnabled ? 'bg-black' : 'bg-white';
  const hostname = window.location.hostname;

  return (
    <div
      className={classNames(
        'fixed top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5',
        className,
        bgColor
      )}
    >
      <Icons.LogoClient
        src={clientLogos[customerKey]}
        className="h-18 w-auto sm:h-20"
      />
      {hostname === 'radoviewerlite.medespacio.com' ? (
        <Icons.RadoViewerByCaduceo className="!h-13 w-auto text-white sm:h-12" />
      ) : !headerConfig ? (
        <Icons.RadoViewer className="h-10 w-auto" />
      ) : (
        <Icons.AboutImage className="!h-13 w-auto text-white sm:h-12" />
      )}

      <div className="w-48">
        <ProgressLoadingBar progress={progress} />
      </div>
      {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
